<template>
  <div class="page-container">
    <h1 class="sub-heading">Encounter</h1>
    <div class="encounter-card" v-html="description"></div>
    <span class="sub-heading">{{ coinBalance }}</span>
    <div class="icon-row">
      <icon-buttons check="/quest" />
    </div>
  </div>
</template>
<style lang="scss">
.encounter-card {
  text-align: justify;
}
</style>
<script>
import IconButtons from '@/components/IconButtons.vue';
import htmlRenderer from '../lib/cmsRichTextHtmlRenderer';

export default {
  components: {
    IconButtons,
  },
  computed: {
    description() {
      return htmlRenderer(this.$store.state.currentGame.encounter.description);
    },
    coinBalance() {
      const { encounter } = this.$store.state.currentGame;
      return encounter.coins > 0
        ? `You gain ${encounter.coins} gold coins`
        : `You lose ${encounter.coins * -1} gold coins`;
    },
  },
};
</script>
